import { combineReducers } from 'redux';
import { Map } from 'immutable';
import { createStructuredSelector } from 'reselect';

import {
	WAREHOUSE_GROUPS_CREATE,
	WAREHOUSE_GROUPS_CREATE_SUCCESS,
	WAREHOUSE_GROUPS_CREATE_FAIL,
	WAREHOUSE_GROUPS_UPDATE,
	WAREHOUSE_GROUPS_UPDATE_SUCCESS,
	WAREHOUSE_GROUPS_UPDATE_FAIL,
	WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS,
	WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS,
	WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL,
	WAREHOUSE_GROUPS_GET_DETAILS,
	WAREHOUSE_GROUPS_GET_DETAILS_SUCCESS,
	WAREHOUSE_GROUPS_GET_DETAILS_FAIL,
	OPTIONS_GET,
	OPTIONS_GET_SUCCESS,
	OPTIONS_GET_FAIL,
} from 'Constants/actionTypes';

const statusReducer = (state = new Map(), action) => {
	switch (action.type) {
	case WAREHOUSE_GROUPS_CREATE:
	case WAREHOUSE_GROUPS_UPDATE:
		return state.set('warehouseGroup', 'submitting');
	case WAREHOUSE_GROUPS_CREATE_SUCCESS:
	case WAREHOUSE_GROUPS_UPDATE_SUCCESS:
		return state.set('warehouseGroup', 'submitted');
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state.set('warehouseGroups', 'fetching');
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return state.set('warehouseGroups', 'fetched');
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS_FAIL:
		return state.set('warehouseGroups', 'has-errors');
	case WAREHOUSE_GROUPS_GET_DETAILS:
		return state.set('warehouseGroup', 'fetching');
	case WAREHOUSE_GROUPS_GET_DETAILS_SUCCESS:
		return state.set('warehouseGroup', 'fetched');
	case WAREHOUSE_GROUPS_CREATE_FAIL:
	case WAREHOUSE_GROUPS_UPDATE_FAIL:
	case WAREHOUSE_GROUPS_GET_DETAILS_FAIL:
		return state.set('warehouseGroup', 'has-errors');
	case OPTIONS_GET:
		return action.payload.tag === 'warehouseGroup' ? state.set('options', 'fetching') : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'warehouseGroup' ? state.set('options', 'fetched') : state;
	case OPTIONS_GET_FAIL:
		return action.payload.tag === 'warehouseGroup' ? state.set('options', 'has-errors') : state;
	default:
		return state;
	}
};

const currentReducer = (state = null, action) => {
	switch (action.type) {
	case WAREHOUSE_GROUPS_CREATE:
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return null;
	case WAREHOUSE_GROUPS_CREATE_SUCCESS:
	case WAREHOUSE_GROUPS_UPDATE_SUCCESS:
	case WAREHOUSE_GROUPS_GET_DETAILS_SUCCESS:
		return action.payload.id;
	default:
		return state;
	}
};

const warehouseGroupsByPageReducer = (state = new Map(), action) => {
	switch (action.type) {
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS:
		return state;
	case WAREHOUSE_GROUPS_FIND_ALL_BY_PAGE_AND_OPTIONS_SUCCESS:
		return new Map(action.payload);
	default:
		return state;
	}
};

const warehouseGroupReducer = (state = new Map(), action) => {
	switch (action.type) {
	case WAREHOUSE_GROUPS_GET_DETAILS:
		return new Map();
	case WAREHOUSE_GROUPS_CREATE_SUCCESS:
	case WAREHOUSE_GROUPS_UPDATE_SUCCESS:
	case WAREHOUSE_GROUPS_GET_DETAILS_SUCCESS:
		return state.set(action.payload.id, action.payload);
	default:
		return state;
	}
};

const optionsReducer = (state = new Map(), action) => {
	switch (action.type) {
	case OPTIONS_GET:
		return action.payload.tag === 'warehouseGroup' ? new Map() : state;
	case OPTIONS_GET_SUCCESS:
		return action.payload.tag === 'warehouseGroup' ? new Map(action.payload.options) : state;
	default:
		return state;
	}
};

export default combineReducers({
	status                : statusReducer,
	current               : currentReducer,
	warehouseGroupsByPage : warehouseGroupsByPageReducer,
	warehouseGroup        : warehouseGroupReducer,
	options               : optionsReducer,
});

export const selector = createStructuredSelector({
	status                : (state) => state.warehouseGroups.status,
	current               : (state) => state.warehouseGroups.current,
	warehouseGroupsByPage : (state) => state.warehouseGroups.warehouseGroupsByPage,
	warehouseGroup        : (state) => state.warehouseGroups.warehouseGroup,
	options               : (state) => state.warehouseGroups.options,
	errors                : (state) => state.errors.get('warehouseGroup'),
});